module.exports = __webpack_public_path__ + "media/common/fonts/template/template-77ce5d1641e1b7d4287de23fe8a17bc0.svg";